export function cepMask(value = ""){
  return value.replace(/^(\d{5})(\d{3})/g, '$1-$2')
}